module.exports = __webpack_public_path__ + "img/search-hero-overflow-nissan.1c560f58.png";